import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  constructor(private http: HttpClient) { }

  saveDocument(data) {
    return this.http.put(
      `${environment.apiHost}/v1/document-library`,
      data
    );
  }

  updateDocument(data) {
    return this.http.patch(
      `${environment.apiHost}/v1/document-library`,
      data
    );
  }

  get(data) {
    return this.http.post(
      `${environment.apiHost}/v1/document-library`,
      data
    );
  }
}
